import { MetricTarget, MetricTargetTimespan } from '@bioliberty/lifemind';
import { getQueryCacheKey } from '../util';
import { HttpMethod } from '../util/http';
import { tms } from './tms';

export interface CreateMetricTargetParams {
  metric: string;
  value: number;
  timespan: MetricTargetTimespan;
}

export interface GetMetricTargetsParams {
  metric?: string;
  timespan?: MetricTargetTimespan;
}

export interface UpdateMetricTargetParams {
  id: number;
  metric: string;
  value: number;
  timespan: MetricTargetTimespan;
}

export interface DeleteMetricTargetParams {
  id: number;
}

const metricTargetsApi = tms.injectEndpoints({
  endpoints: (builder) => ({
    createMetricTarget: builder.mutation<void, CreateMetricTargetParams>({
      query: (body) => ({
        url: `metric-targets`,
        method: HttpMethod.Post,
        body
      }),
      invalidatesTags: ['MetricTargets']
    }),
    getMetricTargets: builder.query<MetricTarget[], GetMetricTargetsParams>({
      query: () => ({
        url: `metric-targets`,
        method: HttpMethod.Get
      }),
      providesTags: (_result, _error, params) => [
        { type: 'MetricTargets', id: getQueryCacheKey(params, 'metric-targets') }
      ]
    }),
    updateMetricTarget: builder.mutation<void, UpdateMetricTargetParams>({
      query: ({ id, ...body }) => ({
        url: `metric-targets/${id}`,
        method: HttpMethod.Put,
        body
      }),
      invalidatesTags: ['MetricTargets']
    }),
    deleteMetricTarget: builder.mutation<void, DeleteMetricTargetParams>({
      query: ({ id }) => ({
        url: `metric-targets/${id}`,
        method: HttpMethod.Delete
      }),
      invalidatesTags: ['MetricTargets']
    })
  })
});

export const {
  useCreateMetricTargetMutation,
  useGetMetricTargetsQuery,
  useUpdateMetricTargetMutation,
  useDeleteMetricTargetMutation
} = metricTargetsApi;
